import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import { authRoutes } from "../../../features/auth/config/authRoutes";

export default function EmailVerifiedRoute() {
  const location = useLocation();
  const { isAuthenticated, status, user } = useAuth();
  const isEmailVerified = String(user?.emailVerified).toLowerCase() === "true";
  const isProfileComplete = String(user?.completeProfile).toLowerCase() === "true";

  if (status === "booting") return null;
  if (!isAuthenticated) return null;

  if (!isEmailVerified) {
    return <Navigate to="/verificar-email" replace />;
  }

  if (!isProfileComplete && location.pathname !== authRoutes.completeSignup) {
    return <Navigate to={authRoutes.completeSignup} replace />;
  }

  return <Outlet />;
}
